import PeuTable from "../CostosFijos/PeuTable";
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionMaquinaria = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionMaquinariaTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionMaquinariaTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionMaquinaria;